import IBaseComponent from '@components/FormFlow/Interfaces/Base/IBaseComponent';
import ISampleComponent, { ISampleOption } from '@components/FormFlow/Interfaces/FormflowComponents/ISampleComponent';
import FormflowContext from '@components/FormFlow/Util/FormflowContext';
import { ComponentType } from '@interfaces/component-type';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Button, Checkbox, Icon, Input, InputNumber, Row, Select } from 'antd';
import React from 'react';

import { InstructionTaskComponent } from '../TextInstructionComponent';

const Option = Select.Option;

interface ISampleTaskComponentStateType {
  instructionTitle: string;
  required: boolean;
  description?: string;
  label: string | undefined;
  options: any[];
  sectionIds: any[];
  samples?: any;
  execAllOnStart: boolean;
  execAllOnEnd: boolean;
};

export class SampleComponent implements ISampleComponent {
  id: string;
  required: boolean;
  type: ComponentType;
  title: string;
  description?: string;
  options: ISampleOption[];
  execAllOnStart: boolean;
  execAllOnEnd: boolean;

  constructor(id: string = '') {
    this.id = id;
    this.required = false;
    this.type = ComponentType.SAMPLE;
    this.title = '';
    this.options = [{
      id: Date.now(),
      sectionId: undefined,
      label: undefined,
      samples: undefined
    }];
    this.execAllOnStart = false;
    this.execAllOnEnd = false
    return this;
  }
}

export default class SampleTaskComponent extends React.Component<ISampleComponent, ISampleTaskComponentStateType> {

  constructor(props: ISampleComponent) {
    super(props);
    this.state = {
      instructionTitle: this.props.title || '',
      description: this.props.description || undefined,
      required: this.props.required || false,
      options: this.props.options,
      label: undefined,
      sectionIds: [''],
      execAllOnStart: this.props.execAllOnStart,
      execAllOnEnd: this.props.execAllOnEnd
    };
  }

  componentDidMount = async () => {
    await this.convertSamplesInit()
  }

  //#region HANDLERS
  handleIntructionTitleChange = async (evt: any) => {
    this.setState({ instructionTitle: evt.target.value });
  }

  handleDescriptionChange = async (evt: any) => {
    this.setState({ description: evt.target.value });
  }

  handleRequiredChange = async (evt: any) => {
    this.setState({ required: evt.target.checked });
  }

  handleLabel = async (evt: any) => {
    this.setState({ label: evt.target.value })
  }

  handleInputLabelChange = async (evt: any) => {
    let selectGoTo: any = []
    for (const options of this.state.samples) {
      selectGoTo.push({ ...options, label: evt.target.value });
    }
    this.setState({
      samples: selectGoTo,
    });

  }

  handleInputSampleChange = (idx: any) => (evt: any) => {
    const selectGoTo = this.state.samples.map((selectGoToItems: any, sidx: number) => {
      if (idx !== sidx) return selectGoToItems;
      return { ...selectGoToItems, samples: evt };
    });
    this.setState({ samples: selectGoTo });
  }


  handleInputItemChange = (idx: number, idxSection: number) => async (evt: any) => {
    const sectionId = Object.assign({}, this.state.samples);

    sectionId[idx].sectionId[idxSection].value = evt
    sectionId[idx].sectionId[idxSection].sample = sectionId[idx].samples

    this.setState({ samples: this.state.samples });
  }


  handleAddNewSample = async () => {
    this.setState({
      samples: this.state.samples.concat([{
        id: Date.now(),
        samples: undefined,
        label: this.state.samples[0].label,
        sectionId: [{ id: Date.now(), value: '', sample: undefined }]
      }]),
    });
  }


  handleAddNewSection = async (idx: number) => {
    const newSamples = Object.assign({}, this.state.samples);
    newSamples[idx].sectionId.push({ id: Date.now(), value: '', sample: undefined })

    this.setState({
      samples: this.state.samples,
    });
  }


  handleRemoveSample = (index: number) => async () => {
    this.setState({
      samples: this.state.samples.filter((section: any, sindex: number) => index !== sindex),
    });

    if (this.state.samples.length === 0) {
      this.setState({
        samples: this.state.samples.concat([{
          id: Date.now(),
          samples: undefined,
          label: undefined,
          sectionId: [{ id: Date.now(), value: '', sample: undefined }]
        }]),
      });
    }
  }

  handleRemoveSectionId = (index: number, idxSection: number) => async () => {
    const newSection = this.state.samples[index].sectionId.filter((section: any, sindex: number) => idxSection !== sindex)
    let newSample = Object.assign({}, this.state.samples);
    newSample[index].sectionId = newSection
    this.setState({
      samples: this.state.samples
    });

  }

  handleExecAllOnStart = async (evt: any) => {
    this.setState({ execAllOnStart: evt.target.checked })
  }
  handleExecAllOnEnd = async (evt: any) => {
    this.setState({ execAllOnEnd: evt.target.checked })
  }
  //#endregion

  onSubmitSampleComponent(updateFormflowWithComponent: (component: IBaseComponent) => void) {
    let newOptions: ISampleOption[] = []

    for (let [idx, items] of this.state.samples.entries()) {
      let sectionsSamples: any = []
      for (let itemsSectionsId of items.sectionId) {
        newOptions.push({
          id: itemsSectionsId.id,
          label: items.label,
          samples: itemsSectionsId.sample,
          sectionId: itemsSectionsId.value
        })
      }
    }

    const newSampleDataComponent: ISampleComponent = {
      id: this.props.id,
      type: ComponentType.SAMPLE,
      title: this.state.instructionTitle,
      description: this.state.description,
      required: this.state.required,
      options: newOptions,
      execAllOnStart: this.state.execAllOnStart,
      execAllOnEnd: this.state.execAllOnEnd
    }

    updateFormflowWithComponent(newSampleDataComponent);
  }

  convertSamplesInit = async () => {
    // console.log('Inicial', this.props.options)
    const samplesValue: number[] = []
    const newSamples: any = []
    for (const option of this.props.options) {
      if (samplesValue.indexOf(option.samples) === -1) {
        newSamples.push({
          id: option.id,
          samples: option.samples,
          label: option.label,
          sectionId: []
        }
        )
        samplesValue.push(option.samples)
      }
    }
    for (const option of this.props.options) {
      const s = newSamples.find((e: any) => e.samples === option.samples)
      s.sectionId.push({ id: option.id, sample: option.samples, value: option.sectionId })
    }

    this.setState({ samples: newSamples })

  }


  render() {

    const {
      instructionTitle,
      required,
    } = this.state

    return (
      <React.Fragment>
        <InstructionTaskComponent
          conditionsTaskComponents={true}
          inputDescriptionValue={this.props.description != undefined ? this.props.description : ''}
          visibleDescription={true}
          inputTitleValue={instructionTitle}
          requiredCheckedValue={required}
          onInputInstructionChange={() => this.handleIntructionTitleChange}
          onChangeDescription={() => this.handleDescriptionChange}
          onChangeRequiredCheckbox={() => this.handleRequiredChange}
          titleComponent={I18n.l("formflow.components.sampleComponent.titleSampleComponent")}
          descriptionComponent={I18n.l("formflow.components.sampleComponent.descriptionSampleComponent")}
        />
        <DividerBorder />
        <Wrapper>
          {this.state.samples &&
            <>
              <div style={{ width: '30%' }}>
                <span>{I18n.l("formflow.components.sampleComponent.labelName")}</span>
                <Input
                  defaultValue={this.state.samples[0].label}
                  onChange={this.handleInputLabelChange}
                />
              </div>
              {this.state.samples.map((samplesItems: any, idx: number) => (
                <div key={idx} className={'box-sample'} style={{ marginTop: '2rem', width: '50%' }}>
                  <Icon
                    style={{ color: 'red', marginRight: '-10px', cursor: "pointer", float: 'right', marginTop: '-10px' }}
                    type="close"
                    onClick={this.handleRemoveSample(idx)}
                  />
                  <span style={{ marginRight: '10px' }}>{I18n.l("formflow.components.sampleComponent.forEach")}</span>
                  <InputNumber
                    min={0}
                    defaultValue={samplesItems.samples}
                    // value={samplesItems.samples}
                    placeholder={'n°'}
                    onChange={this.handleInputSampleChange(idx)}
                    style={{ width: '60px' }}
                  />
                  <span style={{ marginLeft: '10px' }}>{I18n.l("formflow.components.sampleComponent.sectionIds")}</span>
                  <FormflowContext.Consumer>
                    {({ sections }) => (
                      samplesItems.sectionId.map((item: any, idxSection: number) => (
                        <>
                          <div>
                            <Select
                              defaultValue={item.value}
                              onChange={this.handleInputItemChange(idx, idxSection)}
                              placeholder={I18n.l("formflow.components.goToComponent.selectGoToPlaceHolder")}
                              style={{ width: '50%', marginTop: '1rem' }}>
                              {sections.map((section, index) => (
                                <Option key={index} value={section.id}>
                                  {section.id}
                                </Option>
                              ))}
                            </Select>
                            <Icon
                              style={{ color: 'red' }}
                              type="close"
                              onClick={this.handleRemoveSectionId(idx, idxSection)}
                            />
                            {/* <Icon type="plus" onClick={() => this.handleAddNewSection(idx)} /> */}
                          </div>
                        </>
                      ))
                    )}
                  </FormflowContext.Consumer>
                  <div><Icon type="plus" onClick={() => this.handleAddNewSection(idx)} /></div>
                </div>
              ))}
              <Button style={{ marginTop: '3rem' }} onClick={this.handleAddNewSample} className="goepik-btn-border-main">
                <Icon type="plus" /> {I18n.l("formflow.buttons.addSection").toUpperCase()}
              </Button>
            </>
          }
          <div style={{ marginTop: '1rem' }}>
            <div>
              <Checkbox
                style={{ fontSize: '16px' }}
                defaultChecked={this.props.execAllOnStart}
                onChange={this.handleExecAllOnStart}
              >
                {I18n.l("formflow.components.sampleComponent.execAllonStart")}
              </Checkbox>
            </div>
            <div>
              <Checkbox
                style={{ fontSize: '16px' }}
                defaultChecked={this.props.execAllOnEnd}
                onChange={this.handleExecAllOnEnd}
              >
                {I18n.l("formflow.components.sampleComponent.execAllonEnd")}
              </Checkbox>
            </div>
          </div>
        </Wrapper>
        <FormflowContext.Consumer>
          {({ destroyComponentModalWindow, updateFormflowWithComponent }) => (
            <div>
              <ButtonStyle>
                <Row type="flex" justify="end">
                  <Button className="button-cancel" type="primary" onClick={destroyComponentModalWindow} ghost>{I18n.l('common.cancel')}</Button>
                  <Button className="button-save" type="primary" disabled={instructionTitle.length === 0 || instructionTitle.length < 3 ? true : false} onClick={() => { this.onSubmitSampleComponent(updateFormflowWithComponent) }} >{I18n.l('common.save')}</Button>
                </Row>
              </ButtonStyle>
            </div>
          )}
        </FormflowContext.Consumer>
      </React.Fragment>
    );
  }
}

//#region CSS
const DividerBorder = styled.div`
    margin-top: 3rem;    
    margin-bottom: 2rem;
    margin-left: 50px;
    margin-right: 50px;
    border-bottom: 1px solid ${Theme.secondary.midGrey};
`

const Wrapper = styled.div`
    width:100%;
    margin-left: 50px;
    margin-right: 50px;
    .optional-validation-condition-text{
        font-weight: bold;
        margin-top: 2rem;
        margin-bottom: 2rem;
        margin-left: 3rem;
        margin-right: 3rem;
    }

    .box-sample {
        background-color: ${Theme.secondary.supahLightGrey};
        border: 1px solid ${Theme.secondary.midLightGrey};
        margin-bottom: 10px;
        border-radius: 5px;
        font-weight: bold;
        color: ${Theme.secondary.midGrey};
        padding: 1.6rem;
    }
    .none {
      display: none;
    }

    .text-checkbox-validation{
        width:50%;
        margin-top: 1rem;

    }
    .text-input-validation{
        width: 70px;
        margin-left: 5px;
        margin-right: 5px;
        text-align: center;
    }
    .select-item-style{
        margin-bottom: 1rem;
        margin-left: 3rem;
        margin-right: 3rem;
        width 100%;
    }
    .select-title-style{
        margin-top: 2rem;
        margin-left: 3rem;
        margin-right: 3rem;
        width 80%;
    }
    .delete-style{
        margin-top: 2rem;
    }
    .count-input{
        margin-top:2px;
        font-weight: bold;
        color: ${Theme.secondary.midGrey};
    }
    .count-input-red{
        margin-top:2px;
        color: ${Theme.secondary.red};
        font-weight: bold;
    }
    @keyframes shake {
        10%, 90% {
          transform: translate3d(-1px, 0, 0);
        }
      
        20%, 80% {
          transform: translate3d(2px, 0, 0);
        }
      
        30%, 50%, 70% {
          transform: translate3d(-4px, 0, 0);
        }
      
        40%, 60% {
          transform: translate3d(4px, 0, 0);
        }
      }
      .apply-shake {
          animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
      }

`


const ButtonStyle = styled.div`
    float:right;
    margin-top: 15vh;
    margin-right: 50px;
    
    .button-save{
        bottom: 5%;
        width: 6rem;
    }
    .button-cancel{
        bottom: 5%;
        width: 6rem;
        margin-left: -6.5rem;
    }
`;
//#endregion
